import { createUseStyles } from "react-jss";

interface Props {
    isFullscreen: any;
    isMinimalized: any;
    bodyHeight: any;
};
  
  const useStyles = createUseStyles((theme: any) => ({
    root: {
      borderRadius: "10px",
      backgroundColor: theme.colors.white,
      width: (props: Props) => {
        if(props.isMinimalized) return '400px';
        else return '800px';
      },
      maxWidth: '90vw',
      overflow: "hidden",
      margin: "20px",
      maxHeight: 'calc(80% - 40px)',
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 20px 10px 20px",
      maxWidth: 'calc(100% - 40px)',
      cursor: (props: Props) => {
        if(props.isMinimalized) return 'pointer';
        else return '';
      },
      boxShadow: (props: Props) => {
        if(props.isMinimalized) return theme.shadows[2];
        else return '';
      },
      '& p': {
        fontWeight: "bold",
        marginBottom: "0",
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
      },
    },
    wrapper: {
      display: "flex",
      alignItems: "center",
      flex: '1 1 100%',
      maxWidth: 'calc(100% - 40px)',
    },
    defaultTitle: {
      color: theme.colors.black,
    },
    customTitle: {
      color: '#666666',
    },
    buttons: {
      display: 'flex',
      gap: '10px',
      flex: '0 0 fit-content',
    },
    button: {
      padding: '10px',
      width: '40px',
      height: '40px',
      '& > svg': {
        color: theme.colors.primaryBlue[500],
      },
      '&.smallIcon': {
        '& > svg': {
          transform: 'scale(0.8)',
        },
      },
    },
    body: {
      display: 'flex',
      justifyContent: 'center',
      height: (props: Props) => {
        if(props.bodyHeight) return props.bodyHeight + 'px';
        else return '100%';
      },
      backgroundImage: theme.colors.gradient,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      overflow: 'auto',
    },
    bodyWrapper: {
      width: (props: Props) => {
        if(props.isFullscreen) return '80%';
        else return '100%';
      },
      padding: (props: Props) => {
        if(props.isFullscreen) return '20px 0';
        else return '20px';
      },
      flexDirection: 'column',
      gap: '20px',
      height: 'calc(100% - 40px)',
      '&::after': {
        content: `''`,
        display: 'flex',
        width: '100%',
        height: '20px',
      },
    },
    buttonGroup: {
      alignItems: 'center',
    },
    footer: {
      display: "flex",
      flexDirection: 'column',
      gap: '5px',
      padding: "10px 20px",
      width: 'calc(100% - 40px)',
    },
    footerButtons: {
      display: "flex",
      gap: '15px',
      width: '100%',
      justifyContent: "flex-end",
      flexWrap: 'wrap',
      '& > button': {
        width: 'fit-content',
      },
    },
    activityTypePlaceholder: {
      display: 'flex',
      alignItems: 'center',
      color: theme.colors.grey[560],
      fontSize: '14px',
      whiteSpace: 'break-spaces',
      overflowWrap: 'break-word',
      '& > svg': {
        width: '20px',
        height: '20px',
        marginRight: '8px',
        color: 'inherit',
      },
    },
    activityTypeValue: {
      display: "flex",
      alignItems: "center",
      whiteSpace: 'break-spaces',
      overflowWrap: 'break-word',
      '& svg': {
        width: "20px",
        height: "20px",
      },
      '& img': {
        width: "20px",
        height: "20px",
      },
      '& p': {
        marginLeft: "8px",
        fontSize: "14px",
        marginBottom: "0",
      }
    },
    switches: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      marginTop: '16px',
    },
    disabled: {
      color: theme.colors.grey[540],
      fontWeight: '400',
      marginLeft: 'auto',
    },
    deleteButton: {
      marginRight: 'auto',
    },
    info: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    infoDetail: {
      display: 'flex',
      gap: '4px',
      fontSize: '14px',
      alignItems: 'center',
      '& > svg': {
        width: '20px',
        height: '20px',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '12px',
        '& > svg': {
          width: '18px',
          height: '18px',
        },
      },
    },
  }));

  export default useStyles;